module.exports = __webpack_public_path__ + "assets/img/syjl.08aa609a.png";